export default "__VITE_ASSET__Bj1CRIlR__"